"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BadgeType = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const BadgeType = exports.BadgeType = {
  ROUNDED_LARGE_NUMBER: "ROUNDED_LARGE_NUMBER",
  UNDEFINED_LARGE_NUMBER: "UNDEFINED_LARGE_NUMBER"
};

/**
 * The props for the Badge component.
 */

const MAX_VAL = 999;
const units = ["", "k", "M", "B", "T"];
const round = function (value) {
  let unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (value < 1000) {
    const truncatedValue = Number(value.toString().slice(0, 3));
    return "".concat(truncatedValue).concat(units[unit]);
  }
  if (unit >= units.length - 1) {
    return "999T";
  }
  const newValue = value / 1000;
  return round(newValue, unit + 1);
};
const clamp = value => {
  if (value > MAX_VAL) {
    return "".concat(MAX_VAL, "+");
  }
  return value;
};

/**
 * This is a [React](https://reactjs.org/) component for the Vanilla [Badge](https://vanillaframework.io/docs/patterns/badge).
 *
 * It can be used to display a numeric values.
 */
const Badge = _ref => {
  let {
    value,
    badgeType = BadgeType.UNDEFINED_LARGE_NUMBER,
    className,
    isNegative,
    ...spanProps
  } = _ref;
  const badgeClassName = (0, _classnames.default)({
    ["p-badge--negative"]: !!isNegative,
    "p-badge": !isNegative
  }, className);
  let safeValue = Math.round(value);
  if (value < 0) {
    console.error("The value used in the badge should be positive");
    safeValue = 0;
  }
  const formattedValue = badgeType === BadgeType.ROUNDED_LARGE_NUMBER ? round(safeValue) : clamp(safeValue);
  return /*#__PURE__*/_react.default.createElement("span", _extends({}, spanProps, {
    className: badgeClassName
  }), formattedValue);
};
var _default = exports.default = Badge;